// @flow

// Libs
import React from 'react'
import _without from 'lodash/without'

// Constants
import { COUNTRIES_OPTS, US_STATES_OPTS } from 'hfty'
import { PROP_ADDRESS, PROP_CITY, PROP_COUNTRY, PROP_PROVINCE, PROP_POSTAL_CODE } from 'hfty-model-orders'

// Components
import Textfield from '@react-mdc/textfield'
import FormField from '@react-mdc/form-field'
import Select from 'react-select'
import Button from '@react-mdc/button'
import Checkbox from '@react-mdc/checkbox'

// Messages
import { FormattedMessage } from 'react-intl'
import { default as confirmBilling_messages } from '../../messages'

// Style
import { styles as s } from './style'

export default class BillingPopUp extends React.Component {
  props: {
    userBillingInfo: Object,
    isOpen: boolean,
    isBillingInfoChanged: boolean,
    onCancel: Function,
    onSubmit: Function,
    onUpdate: Function,
  }

  state: {
    rememberBillingInfo: string,
    showHint: boolean,
  }

  constructor(props: Object) {
    super(props)

    this.state = {
      rememberBillingInfo: false,
      showHint: false,
    }
  }

  componentWillMount() {
    this.setState({
      ...this.state,
      rememberBillingInfo: this.handleRememberBillingInfo(),
    })
  }

  render(): React.Element<any> {
    const { userBillingInfo, isOpen, isBillingInfoChanged } = this.props
    const { showHint } = this.state

    if (isOpen) {
      return (
        <div style={s.mainWrapper}>
          <form style={s.card}>
            <div style={s.formHeading}>
              <span style={s.formHeadingTitle}>
                <FormattedMessage {...confirmBilling_messages['ConfirmBilling.title']} />
              </span>
            </div>

            <div style={s.formMain}>
              {userBillingInfo &&
                _without(Object.keys(userBillingInfo), PROP_COUNTRY, PROP_PROVINCE).map(
                  (field: string): React.Element<any> => this.renderField(field)
                )}
              <div style={s.selectorsWrapper}>
                {userBillingInfo &&
                  _without(Object.keys(userBillingInfo), PROP_ADDRESS, PROP_CITY, PROP_POSTAL_CODE).map(
                    (field: string): React.Element<any> => this.renderSelect(field)
                  )}
              </div>
            </div>

            <div style={s.rememberWrapper}>
              <Checkbox.Default
                inputId="remember_billing_info"
                name="remember_billing_info"
                checked={this.state.rememberBillingInfo}
                onChange={this.onChangeRememberBilling}
              />
              <span
                onMouseEnter={(): Function => this.handleShowHint('show')}
                onMouseLeave={(): Function => this.handleShowHint('hide')}
              >
                <FormattedMessage {...confirmBilling_messages['ConfirmBilling.remember']} />
              </span>
              <div style={showHint ? s.hintWrapper : { display: 'none' }}>
                <FormattedMessage {...confirmBilling_messages['ConfirmBilling.remember_hint']} />
              </div>
            </div>

            <div style={s.buttons}>
              <Button raised primary style={s.cardFooterButton} onClick={this.onSubmit}>
                {isBillingInfoChanged ? 'Update and Checkout' : 'Checkout'}
              </Button>
              <Button raised style={s.cardFooterButton} primary onClick={this.onCancel}>
                Cancel
              </Button>
            </div>
          </form>
        </div>
      )
    }

    return null
  }

  renderField = (field: string): React.Element<any> => {
    return (
      <FormField style={s.formField} key={field}>
        <Textfield style={s.formTextField}>
          <Textfield.Label htmlFor={field}>
            <FormattedMessage {...confirmBilling_messages[`ConfirmBilling.form_${field}`]} />
          </Textfield.Label>
          <Textfield.Input
            style={{ width: '100%' }}
            id={field}
            name={field}
            value={this.props.userBillingInfo[field]}
            onChange={(e: Function): Function => this.onChange(e.target.name, e.target.value)}
          />
        </Textfield>
      </FormField>
    )
  }

  renderSelect = (field: string): React.Element<any> => {
    return (
      <FormField style={s.selectWrapper} key={field}>
        <label style={s.selectLabel} htmlFor={field}>
          <FormattedMessage {...confirmBilling_messages[`ConfirmBilling.form_${field}`]} />
        </label>
        <Select
          clearable={false}
          name={field}
          id={field}
          value={this.props.userBillingInfo[field]}
          options={this.getSelectOptions(field)}
          style={s.select}
          wrapperStyle={{ width: '100%' }}
          onChange={(e: Function): Function => this.onChange(field, e)}
        />
      </FormField>
    )
  }

  handleRememberBillingInfo = (onSubmit: string): any => {
    if (onSubmit) {
      if (this.state.rememberBillingInfo) {
        localStorage.removeItem('rememberBillingInfo')
        localStorage.setItem('rememberBillingInfo', this.state.rememberBillingInfo)
      }
    }

    return localStorage.getItem('rememberBillingInfo') ? localStorage.getItem('rememberBillingInfo') === 'true' : false
  }

  onChangeRememberBilling = () => {
    this.setState({
      ...this.state,
      rememberBillingInfo: !this.state.rememberBillingInfo,
    })
  }

  handleShowHint = (condition: string) => {
    switch (condition) {
      case 'show':
        this.setState({
          ...this.state,
          showHint: true,
        })
        break
      case 'hide':
        this.setState({
          ...this.state,
          showHint: false,
        })
        break
    }
  }

  getSelectOptions = (fieldType: string): Array => {
    switch (fieldType) {
      case PROP_PROVINCE:
        return US_STATES_OPTS

      case PROP_COUNTRY:
        return COUNTRIES_OPTS
    }
  }

  onChange = (field: string, value: any) => {
    const fieldIsSelect = typeof value === 'object'

    this.props.onUpdate({
      field,
      value: !fieldIsSelect ? value : value.value,
    })
  }

  onSubmit = (e: Object) => {
    e.preventDefault()
    this.handleRememberBillingInfo('onSubmit')
    this.props.onSubmit()
  }

  onCancel = (e: Object) => {
    e.preventDefault()
    this.setState({
      ...this.state,
      rememberBillingInfo: false,
    })
    this.props.onCancel()
  }
}
